import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import InvoicePrint from "../InvoiceReport/InvoicePrint";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
};

export default function InvoiceModal({
  orderByCustomer,
  openInvoice,
  setOpenInvoice,
}) {
  const handleClose = () => setOpenInvoice(false);
  return (
    <div>
      <Modal
        open={openInvoice}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {orderByCustomer && <InvoicePrint invoice={orderByCustomer} />}
        </Box>
      </Modal>
    </div>
  );
}
